/* Night Timeline: Cotton vs CloudThera compare toggle.
   Both fabrics' images and copy live in the DOM; the toggle only flips a
   mode class on the section root (images crossfade, numerals mute, text
   swaps via CSS). One state: mode = 'cloud' | 'cotton', default 'cloud'. */
(function () {
  function initToggle(root) {
    var buttons = [].slice.call(root.querySelectorAll('.dreamey-night-timeline__toggle button'));
    if (!buttons.length) return;

    function setMode(mode) {
      root.classList.toggle('dreamey-night-timeline--cotton', mode === 'cotton');
      buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-mode') === mode));
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        setMode(b.getAttribute('data-mode'));
      });
    });
  }

  function init() {
    document.querySelectorAll('.dreamey-night-timeline').forEach(initToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
